import React from 'react';
import {
  bool,
  string,
  func,
} from 'prop-types';
import ChevronDown from '../../../../themes/svg/chevronDown';
import ChevronUp from '../../../../themes/svg/chevronUp';

const ExpandToggle = props => (
  <button className={`expander${!props.isVisible ? ' hidden' : ''}`} onClick={() => props.toggleExpandItem(props.itemId)}>
    {props.isOpen ? <ChevronUp /> : <ChevronDown />}
  </button>
);

ExpandToggle.propTypes = {
  isOpen: bool.isRequired,
  itemId: string.isRequired,
  toggleExpandItem: func.isRequired,
  isVisible: bool,
};

ExpandToggle.defaultProps = {
  isVisible: true,
};

export default ExpandToggle;
